import { FaWhatsapp } from "react-icons/fa";
import { useEffect } from "react";
import { useLocation } from "react-router";

const PrivacyPolicy = () => {
    const {pathname} = useLocation(); 
    useEffect(()=> {
        window.scrollTo(0,0);
    },[pathname]);
    return (
        <>
            <div>
                {/* navbar      */}
                <div className="bg-gray-50 p-5 shadow-lg flex justify-between items-center">
                    <div>
                        <h1 className="text-4xl font-bold">MyReading</h1>
                    </div>
                    <div className="flex items-center space-x-2">

                        <p className="text-lg font-bold">+91 9309140606</p>
                        <a
                            href="https://wa.me/919309140606"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaWhatsapp className="cursor-pointer hover:scale-110 text-green-500" size={24} />
                        </a>
                    </div>
                </div>
                {/* all textual content  */}
                <div className="flex flex-col justify-center p-5 max-w-5xl mx-auto">
                    <h1 className="text-2xl text-gray-800 font-bold mb-2">Privacy Policy</h1>
                    <p className="text-sm mb-2"> Effective Date: 03-12-2025 </p>
                    <p className="mb-3">ShivayTech built the MyReading app as a service. This SERVICE is provided by ShivayTech and is intended for use as is. This page is used to inform users regarding our policies related to the collection, use, and disclosure of personal information for anyone choosing to use our Service.</p>
                    <div className="p-4">
                        <ul className="list-disc space-y-4 p-3">
                            <li>
                                <span className="font-bold">Information Collection and Use:</span> We do not knowingly collect or solicit personal data from children under the age of 13. The app does not store personal data on our servers. We may collect anonymous usage statistics (such as crash reports and performance data) to improve stability and performance. These data do not identify individual users.
                            </li>
                            <li>
                                <span className="font-bold">Location Data:</span> Our app does not collect or use any location data.
                            </li>
                            <li>
                                <span className="font-bold">Third-party Services and SDKs:</span> This app may include third-party libraries like Google Play Services and Firebase Crashlytics that collect anonymous data but no personal identifying information.
                            </li>
                            <li>
                                <span className="font-bold">Advertising:</span> Our app does not display ads or use advertising networks.
                            </li>
                            <li>
                                <span className="font-bold">Cookies:</span> This Service does not use cookies explicitly. However, some third-party services may use cookies to improve their services. You can control cookies through your device settings.
                            </li>
                            <li>
                                <span className="font-bold">Security:</span> We value your trust and strive to use commercially acceptable means of protecting your data. However, no method of internet transmission or electronic storage is 100% secure.
                            </li>
                            <li>
                                <span className="font-bold">Links to Other Sites:</span> This Service may contain links to other sites. We strongly advise reviewing the Privacy Policy of these websites.
                            </li>
                            <li>
                                <span className="font-bold">Children's Privacy:</span> Our app complies with Google Play Families Policy. We do not knowingly collect personal information from children. If we learn that a child has provided personal information to us, please contact us immediately. Parents can contact us for any concerns.
                            </li>
                            <li>
                                <span className="font-bold">Additional School-Specific Policy:</span> All student and school-related data is uploaded by the respective school admin. MyReading does not collect data directly from students or parents. Schools are responsible for data accuracy. We do not verify or modify uploaded data.
                            </li>
                            <li>
                                <span className="font-bold">Third-Party Access:</span> We do not share data with third parties unless required by law.
                            </li>
                            <li>
                                <span className="font-bold">Technical Responsibility:</span> In case of website downtime or performance issues, MyReading takes full responsibility and will resolve issues promptly.
                            </li>
                            <li>
                                <span className="font-bold">Changes to This Policy:</span> We may update this Privacy Policy from time to time. You are advised to review this page periodically.
                            </li>
                            <li>
                                <span className="font-bold">Contact Us:</span> If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at: <a href="mailto:info@shivaytech.com">info@shivaytech.com</a>.
                            </li>
                        </ul>
                    </div> 
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy;